import { useEffect, useState } from "react";
import { deleteMessage } from "../api/notification.api";

const NotificationDrawer = ({
  message,
  onClose,
  onDelete,
  onToggleRead,
}: {
  message: any;
  onClose: () => void;
  onDelete: (id: number) => void;
  onToggleRead: (id: number) => void;
}) => {
  const [localMessage, setLocalMessage] = useState(message);

  useEffect(() => {
    setLocalMessage(message);
  }, [message]);

  if (!localMessage) return null;

  return (
    <>
      <div
        onClick={onClose}
        className="fixed inset-0 bg-black/30 backdrop-blur-sm z-40"
      />

      <div className="fixed right-0 top-[64px] h-[calc(100vh-64px)] w-full sm:w-[420px] lg:w-[520px] bg-white shadow-2xl border-l z-50 flex flex-col">

        <div className="flex items-center justify-between px-6 py-4 border-b bg-gray-50">

          <h3 className="text-lg font-semibold text-gray-800">
            {localMessage.subject}
          </h3>

          <div className="flex items-center gap-2">

            {/* <button
              onClick={() => {
                onToggleRead(localMessage.id);
                setLocalMessage((prev: any) => ({
                  ...prev,
                  read: !prev.read,
                }));
              }}
              className="px-3 py-1 text-sm bg-gray-200 rounded hover:bg-gray-300"
            >
              {localMessage.read ? "Mark as Unread" : "Mark as Read"}
            </button> */}

            <button
              onClick={async () => {
                try {
                  await deleteMessage(localMessage.id);

                  onDelete(localMessage.id);

                } catch (e) {
                  console.error("Delete failed");
                }
              }}
              className="px-3 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600"
            >
              Delete
            </button>

            <button
              onClick={onClose}
              className="w-8 h-8 flex items-center justify-center rounded-md bg-gray-300 hover:bg-gray-400"
            >
              ×
            </button>

          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-6">

          <div className="flex items-start gap-4 mb-6">

            <div className="w-11 h-11 rounded-full bg-indigo-100 flex items-center justify-center font-semibold text-indigo-600">
              {localMessage.sender.first_name[0]}
            </div>

            <div className="flex-1">

              <div className="flex justify-between">
                <div className="font-semibold text-gray-800">
                  {localMessage.sender.first_name} {localMessage.sender.last_name}
                </div>

                <div className="text-sm text-gray-400">
                  {new Date(localMessage.created_at).toLocaleString()}
                </div>
              </div>

              <div className="text-sm text-gray-400">
                to: me
              </div>

            </div>

          </div>

          <div className="text-gray-700 whitespace-pre-line leading-relaxed">
            {localMessage.body}
          </div>

        </div>
      </div>
    </>
  );
};

export default NotificationDrawer;